import { createContext, useContext } from 'react';

export type AuthUser = {
  id: number;
  email: string;
  firstName?: string;
  lastName?: string;
  role: 'customer' | 'admin';
  companyId?: number;
};

export type AuthContext = {
  user: AuthUser | null;
  token: string | null;
  login: (token: string, user: AuthUser) => void;
  logout: () => void;
  isAdmin: boolean;
};

export const AuthCtx = createContext<AuthContext>({
  user: null,
  token: null,
  login: () => {},
  logout: () => {},
  isAdmin: false,
});

export const useAuth = () => useContext(AuthCtx);
